<template>
  <div class="input-pair">
    <div v-for="(pair, i) in pairs" class="input-pair__pair">
      <div class="input-pair__col">
        <div class="input-pair__label">{{ keyLabel }}</div>
        <div class="input-pair__value">{{ pair[keyLabel] }}</div>
      </div>
      <div class="input-pair__col" style="overflow: hidden">
        <div class="input-pair__label">{{ valueLabel }}</div>
        <div class="input-pair__value" :title="pair[valueLabel]">
          {{ pair[valueLabel] }}
        </div>
      </div>
      <div class="input-pair__col" style="display: flex">
        <button @click="removePair(i)">Remove</button>
      </div>
    </div>
    <div>
      <input
        type="text"
        name="key"
        v-model="inputKey"
        :placeholder="keyLabel"
      />
      <input
        type="text"
        name="value"
        v-model="inputValue"
        :placeholder="valueLabel"
      />
      <button @click="addPair">Add</button>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Draggable from "vuedraggable";
export default {
  components: { Draggable },
  props: ["value", "key-label", "value-label"],
  data() {
    return {
      inputKey: "",
      inputValue: ""
    };
  },
  computed: {
    pairs() {
      return this.value || [];
    }
  },
  methods: {
    addPair() {
      let pair = {};
      pair[this.keyLabel] = this.inputKey;
      pair[this.valueLabel] = this.inputValue;
      this.$emit("input", [...this.pairs, pair]);
      this.inputKey = "";
      this.inputValue = "";
    },
    removePair(i) {
      const pairs = JSON.parse(JSON.stringify(this.pairs)); // clone pairs so we dont mutate prop
      pairs.splice(i, 1);
      this.$emit("input", pairs);
    }
  }
};
</script>
<style lang="scss">
.input-pair {
  &__col {
    // overflow: hidden;
    padding: 0 10px 0 0;
  }

  &__pair {
    display: flex;
    margin-bottom: 1rem;
  }

  &__label {
    text-transform: uppercase;
  }

  &__value {
    width: auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
